import { updateUrlWithKeyValue } from './url-params';

export const SYI_SOURCE_QUERY = 'source';

export const SyiEntrySource = {
    HEADER: 'header',
    SIDE_MENU: 'side_menu',
    LOGIN_SELL: 'login_sell',
    SUCCESS_MODAL: 'success_modal',
    HOME_BANNER: 'home_banner',
    CITY_BANNER: 'city_banner',
    MMA_EMPTY: 'mma_empty',
    MMA_EDIT: 'mma_edit',
    MMA_REPOST: 'mma_repost',
    MMA_RESTORE: 'mma_restore',
    REPORT_ISSUE: 'report_issue',
    BING3PA: 'bing3pa',
    VIP_SELL_ONE: 'vip_sell_one',
    CARS_LANDING: 'cars_landing',
    SELL_MY_CAR: 'sell_my_car',
    INSTANT_POST: 'instant_post',
} as const;

export type SyiEntrySourceValue = typeof SyiEntrySource[keyof typeof SyiEntrySource];

export function getSyiSourceFromHref(href?: string | null): string | undefined {
    if (!href) {
        return undefined;
    }

    const queryIndex = href.indexOf('?');
    if (queryIndex === -1) {
        return undefined;
    }

    const search = href.slice(queryIndex + 1).split('#')[0];
    const value = new URLSearchParams(search).get(SYI_SOURCE_QUERY);
    return value || undefined;
}

export function withSyiSource(url: string, source?: string | null): string {
    if (!source) {
        return url;
    }

    return updateUrlWithKeyValue(url, SYI_SOURCE_QUERY, source) ?? url;
}

export function applySyiSourceFromHref(
    params: Record<string, string>,
    href?: string | null
): Record<string, string> {
    const source = getSyiSourceFromHref(href);
    if (!source) {
        return params;
    }

    return { ...params, [SYI_SOURCE_QUERY]: source };
}
